






















import Enumerable from "linq";
import { Component, Mixins, Prop } from "vue-property-decorator";
import { FormatReference, FormatSet } from "../../domain/format";
import {
  NavigationPane,
} from "../panes";
import { SpecifiedPatientViewMixin } from "../patient/mixins";
import { PatientFindDialogController } from "../patient/dialogs";
import NewDocumentFormatSelector from "./selectors/NewDocumentFormatSelector.vue";
import { FormatValidatableMixin } from "../format/mixins";
import { WindowOpener } from "../system/utilities";
import { WindowsOpenRequest } from "../../domain/localhost/items";

@Component({
  components: {
    PatientFindDialogController,
    formatSelector: NewDocumentFormatSelector,
    NavigationPane,
  },
})
export default class NewDocumentFormatSelectView extends Mixins(SpecifiedPatientViewMixin, FormatValidatableMixin) {
  @Prop({ default: null })
  formatName: string;

  @Prop()
  folderId: string;

  @Prop()
  defaultFormatTabName: string;

  @Prop()
  documentKindIds: number[];

  @Prop()
  institutionNo: string;

  @Prop()
  regionalInstitutionNo: string;

  @Prop()
  hisInfoGetterParameter: string;

  @Prop()
  problemNo: string;

  @Prop()
  defaultToolTabName: string;

  @Prop()
  shouldIndicatePrintButtonForcibly: boolean;

  data(): any {
    return {
      format: null as FormatReference,
      selectedFormatSet: null as FormatSet,
    };
  }
  format: FormatReference;
  selectedFormatSet: FormatSet;

  get enableFormatSetTabs(): boolean {
    return this.$store.getters.configuration.behavior.format.formatSet.isEnable;
  }

  openEditor(): void {
    this.validateAndOpenEditor();
  }

  private async validateAndOpenEditor(): Promise<void> {
    if (!this.patient || !this.format) { return; }
    const isOk = await this.validateFormat(this.format, false);
    if (!isOk) { return; }
    this.openEditNewDocumentWindow(this.format);
  }

  private async validateAndOpenEditorSet(): Promise<void> {
    if (!this.patient || !this.selectedFormatSet) { return; }
    const availableFormats = this.selectedFormatSet.formats.filter(f => !f.deleted && !f.expired);
    if (availableFormats.length === 0) {
      return;
    }
    const isOk = await this.validateFormats(availableFormats, false);
    if (!isOk) { return; }
    if (this.$configuration.behavior.format.formatSet.shouldOpenWindowsWithUrlScheme) {
      const request = this.createWindowsOpenRequest(availableFormats);
      await WindowOpener.requestOpenWindows(request);
    } else {
      for (const format of availableFormats) {
        try {
          // 連続で開くにはブラウザのpopup brokcerを解除しておく必要あり
          this.openEditNewDocumentWindow(format);
        } catch (e) {
          this.$error("エラー", "新規ウィンドウを開く処理中にエラーが発生しました。", e);
        }
        // 不要かもだが念のためsleepを入れている
        await this.$sleep(100);
      }
    }
  }

  private createWindowsOpenRequest(formats: FormatReference[]): WindowsOpenRequest {
    const request = new WindowsOpenRequest();
    request.urls = Enumerable.from(formats)
      .select(f => WindowOpener.toUrlEncodedUrl("/EditNewDocument", this.createOpenEditNewDocumentWindowParameter(f)))
      .toArray();
    return request;
  }

  private openEditNewDocumentWindow(format: FormatReference): void {
    // 別Windowで開く.(完全SPAにするとメモリリーク発生による問題が顕在化しやすくなる恐れがあるため.)
    this.$openWindow(
      "/EditNewDocument",
      this.createOpenEditNewDocumentWindowParameter(format),
    );
  }

  private createOpenEditNewDocumentWindowParameter(format: FormatReference): { [key: string]: string } {
    return {
      patientNo: this.patient.id,
      formatId: format.id.toString(),
      institutionNo: this.institutionNo,
      regionalInstitutionNo: this.regionalInstitutionNo,
      hisInfoGetterParameter: this.hisInfoGetterParameter,
      problemNo: this.problemNo,
      defaultToolTabName: this.defaultToolTabName,
      shouldIndicatePrintButtonForcibly: (this.shouldIndicatePrintButtonForcibly != null) ? this.shouldIndicatePrintButtonForcibly.toString() : null,
    };
  }

  openDocumentList(): void {
    if (!this.patient) {
      return;
    }
    // 別Windowで開く.(完全SPAにするとメモリリーク発生による問題が顕在化しやすくなる恐れがあるため.)
    this.$openWindow(
      "/ShowPatientDocumentList",
      {
        patientNo: this.patient.id,
      }
    );
  }

  onFormatSetSelectionChanged(value: FormatSet): void {
    this.selectedFormatSet = value;
  }

  onFormatSetDoubleClicked(): void {
    this.validateAndOpenEditorSet();
  }
}
